import * as signalR from "@microsoft/signalr";
import { SOCKET_URL } from "../config/api.js";
 
class SignalRService {
  connection = null;
  connecting = false;
  started = false;
  listeners = new Map();
  
  getConnection(token) {
    if (!this.connection) {
      this.connection = new signalR.HubConnectionBuilder()
        .withUrl(SOCKET_URL, {
          accessTokenFactory: () => token,
          skipNegotiation: true,
          transport: signalR.HttpTransportType.WebSockets,
        })
        .withAutomaticReconnect([0, 2000, 5000, 10000])
        .configureLogging(signalR.LogLevel.Information)
        .build();
 
      this.registerInternalHandlers();
    }
 
    return this.connection;
  }
 
  registerInternalHandlers() {
    this.connection.on("SeedStatus", (data) => {
      this.emit("SeedStatus", data);
    });
 
    this.connection.onreconnected(async () => {
      try {
        const groupId = JSON.parse(localStorage.getItem("user") || "{}")?.groupId;
        const companyId = JSON.parse(localStorage.getItem("user") || "{}")?.companyId;
        await this.connection.invoke("JoinCompanyGroup", `${companyId}-${groupId}`);
        console.log("🔁 Rejoined group after reconnect");
      } catch (err) {
        console.error("Rejoin failed:", err);
      }
    });
  }
 
  async start(token) {
    if (this.connecting || this.started) return;
 
    this.connecting = true;
 
    try {
      const connection = this.getConnection(token);
 
      if (connection.state === signalR.HubConnectionState.Disconnected) {
        await connection.start();
        console.log("✅ SignalR Connected");
        const groupId = JSON.parse(localStorage.getItem("user") || "{}")?.groupId;
        const companyId = JSON.parse(localStorage.getItem("user") || "{}")?.companyId;
        await connection.invoke("JoinCompanyGroup", `${companyId}-${groupId}`);
        console.log("📡 Joined group");
      }
 
      this.started = true;
    } catch (err) {
      console.error("❌ SignalR start error:", err);
 
      setTimeout(() => {
        this.started = false;
        this.connecting = false;
      }, 5000);
    } finally {
      this.connecting = false;
    }
  }
 
  stop() {
    if (this.connection) {
      this.connection.stop();
      this.connection = null;
      this.started = false;
      this.connecting = false;
    }
  }
 
  on(event, callback) {
    this.listeners.set(callback, event);
    this.connection?.on(event, callback);
  }
 
  off(event, callback) {
    this.connection?.off(event, callback);
    this.listeners.delete(callback);
  }
 
  emit(event, data) {
    for (const [cb, ev] of this.listeners.entries()) {
      if (ev === event) cb(data);
    }
  }
}
 
export const signalRService = new SignalRService();